import store from '@/store'
import { SERVER_URL } from '@/constants/config'

export default [
  {
    header: 'menu.technical',
  },
  {
    title: 'menu.logs-viewer',
    href: () => `${SERVER_URL}/admin/log-viewer?access_token=${store.getters['auth/token']}`,
    icon: 'EyeIcon',
  },
  {
    title: 'menu.telescope',
    href: () => `${SERVER_URL}/telescope?access_token=${store.getters['auth/token']}`,
    icon: 'SearchIcon',
  },
  {
    title: 'menu.horizon',
    href: () => `${SERVER_URL}/horizon?access_token=${store.getters['auth/token']}`,
    icon: 'SquareIcon',
  },
  {
    title: 'menu.documentation',
    href: () => 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-1/dashboard/ecommerce',
    icon: 'FileTextIcon',
  },
]
